import React from 'react';

interface LayerFormatPreviewProps {
  name: string;
  color: string;
  textColor: boolean; // true = dark (#000), false = light (#fff)
}

export const LayerFormatPreview: React.FC<LayerFormatPreviewProps> = ({
  name,
  color,
  textColor,
}) =>
{
  return (
    <span
      className="inline-block px-2 py-0.5 rounded text-xs font-medium truncate max-w-[120px]"
      style={{
        backgroundColor: color,
        color: textColor ? '#000000' : '#ffffff',
      }}
    >
      {name || 'Preview'}
    </span>
  );
};
